import _ from "lodash";
import React, { useCallback, useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import FullScreenLoader from "../../components/widgets/FullScreenLoader";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  activitySearchFormUpdate,
  activitySearchRequest,
} from "../../actions/search/activities_search";
import { validateActivitySearch } from "../../components/MainSearchForm/activity/helpers";
import { activitiesErrorMsgs } from "../../errors";

function recreateFormData(decoded_data) {
  const data = {
    adults: decoded_data.adt,
    children: decoded_data.chd,
    children_ages: decoded_data.ages,
    date_from: decoded_data.in,
    date_to: decoded_data.out,
    destination_code: decoded_data.dst_c,
    destination_meta: decoded_data.dst_m,
  };
  return data;
}

const styles = createUseStyles({
  DeepActivitySearch: (props) => ({
    position: "absolute",
    background: "#FAFAFA",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    ..._.get(props, "customStyles.DeepActivitySearch", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
});
const DeepActivitySearch = ({ encoded_data }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({
    type,
    brand,
    objName: "DeepActivitySearch",
  });

  const classes = styles({ customStyles });

  const source_entity = useSelector((state) =>
    _.get(state.WebsiteMetadata, "metadata.source_entity")
  );

  function onError() {
    toast.warning(activitiesErrorMsgs.searchForm.init_search, {
      duration: 5000,
    });
    history.push("/");
  }

  if (!encoded_data) {
    onError();
  }

  var decoded_data = {};
  try {
    decoded_data = recreateFormData(JSON.parse(window.atob(encoded_data)));
  } catch (error) {
    onError();
  }

  const onFormUpdate = useCallback(
    ({ form }) => dispatch(activitySearchFormUpdate({ form })),
    [dispatch]
  );

  const onFormSearch = useCallback(
    () => dispatch(activitySearchRequest({ redirect: true, history })),
    [dispatch]
  );

  async function onSearch() {
    await onFormUpdate({
      form: decoded_data,
    });
    onFormSearch();
  }

  // Execute search
  useEffect(() => {
    if (!source_entity) {
      return;
    }

    if (_.isEmpty(decoded_data)) {
      return;
    }

    if (
      !validateActivitySearch({
        values: {
          destinationObj: { destination_code: decoded_data.destination_code },
          datesArray: [decoded_data.checkIn, decoded_data.checkOut],
        },
        showToast: false,
      })
    ) {
      onError();
      return;
    }

    onSearch();
  }, [encoded_data, source_entity]);

  return (
    <div className={classes.DeepActivitySearch}>
      <FullScreenLoader />
    </div>
  );
};
DeepActivitySearch.propTypes = {
  encoded_data: PropTypes.string.isRequired,
};
export default DeepActivitySearch;
